import Vue from "vue";
import url from "./apiurls";
import { store } from "../store/store";

export const customerApi = new Vue({
  methods: {
    getCustomerDetails(role) {
      return new Promise((resolve, reject) => {
        const getUrl = `${url.getCustomerDetails}/${role}`;
        this.$http
          .get(getUrl)
          .then(res => {
            store.dispatch("user/setUserData", res.data);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getSubscribedCourses(role) {
      return new Promise((resolve, reject) => {
        const getUrl = `${url.getSubscribedCourses}${role}`;
        this.$http
          .get(getUrl)
          .then(res => {
            store.dispatch(
              "user/setSubscribedCourses",
              res.data.subscribed_courses
            );
            store.dispatch(
              "user/setSubscribedLiveCourses",
              res.data.subscribed_live_courses
            );
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getTeacherCourses() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.getTeacherCourses)
          .then(res => {
            store.dispatch("user/setTeacherCourses", res.data.courses);
            store.dispatch("user/setTeacherLiveCourses", res.data.live_courses);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    editCustomerDetails(userData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.editCustomerDetails, userData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    reviewCourse(reviewData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.courseReview, reviewData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    reviewTeacher(reviewData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.teacherReview, reviewData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    followTeacher(teacherData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.followTeacher, teacherData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    unfollowTeacher(teacherData) {
      return new Promise((resolve, reject) => {
        const postUrl = `${url.unfollowTeacher}/${teacherData.teacher_id}`;
        this.$http
          .post(postUrl)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getFollowingTeachers() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.getFollowingTeachers)
          .then(res => {
            store.dispatch("teacher/setFollowingTeachers", res.data);
            const allTeachers = store.getters["teacher/getAllTeachers"];
            allTeachers.forEach(teacher => {
              res.data.forEach(teacherData => {
                if (teacher.teacher_id === teacherData.teacher_id) {
                  teacher.isFollowing = true;
                }
              });
            });
            store.dispatch("teacher/setAllTeachers", allTeachers);
            resolve(res);
          })
          .catch(e => {
            if (e.status === 404) {
              store.dispatch("teacher/setFollowingTeachers", []);
            }
            reject(e);
          });
      });
    },
    editTeacherReview(teacherData) {
      return new Promise((resolve, reject) => {
        const getUrl = `${url.editTeacherReview}?teacher_id=${
          teacherData.teacher_id
        }`;
        this.$http
          .get(getUrl)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    editCourseReview(courseData) {
      return new Promise((resolve, reject) => {
        const getUrl = `${url.editCourseReview}/${courseData.course_id}`;
        this.$http
          .get(getUrl)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    addToWishlist(courseData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.addToWishlist, courseData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    removeFromWishlist(courseData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.removeFromWishlist, courseData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getWishlist() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.getWishlist)
          .then(res => {
            store.dispatch("user/setWishlist", res.data);
            resolve(res);
          })
          .catch(e => {
            if (e.status === 404) {
              store.dispatch("user/setWishlist", []);
            }
            reject(e);
          });
      });
    },
    searchTeacher(searchKey) {
      return new Promise((resolve, reject) => {
        const getUrls = `${url.searchTeacher}${searchKey}`;
        this.$http
          .get(getUrls)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    requestACourse(requestData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.requestACourse, requestData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    contactUs(contactDetails) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.contactUs, contactDetails)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
});
